import { SharedInputEdit } from '../../components/SharedInputEdit';
import { SharedSelect } from '../../components/SharedSelect';

export function OperationsInput(): JSX.Element {
    return (
        <div className="operations">
            <SharedInputEdit inputName='facility_opening_hours'/>
            <SharedInputEdit inputName='facility_opening_days'/>
            <SharedInputEdit inputName='percent_exam_event'/>
            <SharedInputEdit inputName='admin_fee_rescheduledPatient'/>
            <SharedInputEdit inputName='inHouse_engineer_cost'/>
            <SharedSelect inputName='rate_HTM_org_perfomance'/>
        </div>
    );
}
